import { useEffect, useState } from 'react';
import { GridItem } from 'src/components/common/grids';
import { Container, LabelStatus } from './styles';
import Table from '../../common/tables';
import { TableRow } from '../../common/tables/TableRow';
import { TableCell } from '../../common/tables/TableCell';
import { TableHeader } from '../../common/tables/TableHeader';
import { getScoringPrograms } from 'src/apis/scoringPrograms';
import Title from 'src/components/common/Title';
import Loading from 'src/components/common/Loading/Loading';
import EditProgram from '../EditProgram';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/RootState';
import Modal from 'src/components/common/modal/Modal';
import { Button } from '@habitech/call-to-action';

const statusCode = {
    INACTIVE: 0,
    ACTIVE: 1,
};

const status = {
    [statusCode.INACTIVE]: 'inactivo',
    [statusCode.ACTIVE]: 'activo',
};

const Status = ({ code }) => <LabelStatus className={status[code]}>{status[code]}</LabelStatus>;

const ProgramList = ({ loadingList, setLoadingList }) => {
    const [programs, setPrograms] = useState([]);
    const [showExecute, setShowExecute] = useState(false);
    const [programToExecute, setProgramToExecute] = useState('');
    const token = useSelector((state: RootState) => state.User.token);

    useEffect(() => {
        if (loadingList) {
            getScoringPrograms({ token }).then((res) => {
                setPrograms((res.data || []).filter((program) => program.is_active !== -1));
                setLoadingList(false)
            });
        }
    }, [loadingList, setLoadingList, token]);

    return (
        <Container>
            <GridItem>
                <Title>Listado de programas</Title>
            </GridItem>
            <GridItem>
                {loadingList ? (
                    <Loading height="80%" />
                ) : (
                    <>
                        <Table>
                            <thead>
                                {['ID', 'Nombre del Programa', 'Descripción', 'Score (puntos)', 'vigencia', 'Status', 'Acción'].map((item) => (
                                    <TableHeader key={item}>{item}</TableHeader>
                                ))}
                            </thead>
                            <tbody>
                                {programs.map(({ id, name, description, is_active, number_score, days }) => (
                                    <TableRow key={`row-codes-${id}`}>
                                        <TableCell>{id}</TableCell>
                                        <TableCell>{name}</TableCell>
                                        <TableCell>{description}</TableCell>
                                        <TableCell>{number_score}</TableCell>
                                        <TableCell>
                                            <b>{days}</b> días
                                        </TableCell>
                                        <TableCell>
                                            <Status code={is_active} />
                                        </TableCell>
                                        <TableCell>
                                            <EditProgram initialValues={{ id, name, description, is_active, number_score, days }} setLoadingList={setLoadingList} />
                                            <span style={{ marginLeft: 8 }}>
                                                <Button
                                                    dataId={`execute-program-${id}`}
                                                    variant="primary"
                                                    originType="pcom"
                                                    size="medium"
                                                    onClick={() => {
                                                        setProgramToExecute(name);
                                                        setShowExecute(true);
                                                    }}
                                                >
                                                    Ejecutar
                                                </Button>
                                            </span>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </tbody>
                        </Table>
                        {showExecute && (
                            <Modal onClose={() => setShowExecute(false)}>
                                <div style={{ textAlign: 'center', paddingTop: '16px' }}>
                                    <Title>Aplicar Scoring</Title>
                                </div>
                                <p style={{ textAlign: 'center' }}>
                                    Vas a Aplicar el Scoring para el programa <b>{programToExecute}</b>, ¿Estás Seguro?
                                </p>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: 8, padding: '16px' }}>
                                    <Button dataId="execute-confirm-yes" variant="primary" originType="pcom" size="medium" onClick={() => setShowExecute(false)}>Sí</Button>
                                    <Button dataId="execute-confirm-no" variant="stroke" originType="pcom" size="medium" onClick={() => setShowExecute(false)}>No</Button>
                                </div>
                            </Modal>
                        )}
                    </>
                )}
            </GridItem>

        </Container>
    );
};

export default ProgramList;
